module.exports = __webpack_public_path__ + "img/SHINHANFINANCE.05f2de49.svg";